import React, { useEffect, useState } from "react";
import "../styles/template.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { createSearchParams, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../assets/images/logo-black-2.png";
import secondaryImage from "../assets/images/swageazy-mascot-new-Logo.png";
import axios from "axios";
import { toast } from "react-toastify";
import LayoutComponent from "./LayoutComponent";
import GradientHeader from "./GradientHeader";

export const Redemption = () => {
  const [loading, setLoading] = useState(true);
  const [selectedPack, setSelectedPack] = useState(null);

  let navigate = useNavigate();
  const [templateData, setTemplateData] = useState({
    backgroundColor: "",
    logoImageUrl: "",
    secondaryImageUrl: "",
    heading: "",
    content: "",
    buttonColor: "",
    has_multiple_choice: "",
    layout: 2,
    buttonText: "",
    textColor: "",
    ctaColor: "",
    footerColor: "",
    headerColor: "",
    footerText: "",
    customerId: null,
  });
  const queryParameters = new URLSearchParams(window.location.search);
  const token = queryParameters.get("token");
  let params = { token: token };

  useEffect(() => {
    if (selectedPack) {
      navigate(`/redemption/details?token=${token}`, {
        state: { selectedPack },
      });
    }
  }, [selectedPack]);

  useEffect(() => {
    if (token === null || token === "" || token === undefined) {
      navigate("/");
      setTemplateData({
        logoImageUrl: logo,
        secondaryImageUrl: secondaryImage,
      });
      setLoading(false);
      return;
    }
    getTemplateIdFromCoupon();
  }, []);

  function getTemplateIdFromCoupon() {
    axios
      .get(
        `${process.env.REACT_APP_URL}/v4/customer/redemption/template?token=${token}`
      )
      .then((response) => {
        setTemplateData({
          backgroundColor:
            response.data.result.page_background_color ||
            response.data.result.pageBackgroundColor,
          logoImageUrl:
            response.data.result.logo_image_url ||
            response.data.result.logoImageUrl,
          secondaryImageUrl:
            response.data.result.secondary_image_url ||
            response.data.result.secondaryImage,
          heading: response.data.result.heading,
          content: response.data.result.content,
          buttonColor:
            response.data.result.button_color ||
            response.data.result.buttonColor,
          has_multiple_choice: response.data.result.has_multiple_choice,
          layout: response.data.result.layout || 2,
          buttonText: response.data.result.button_text || "Redeem Your Gift",
          textColor:
            response.data.result.text_color || response.data.result.textColor,
          ctaColor:
            response.data.result.cta_color || response.data.result.ctaColor,
          footerColor: response.data.result.footer_color || "",
          headerColor: response.data.result.header_color || "",
          footerText: response.data.result.footer_text || "",
          customerId: response.data.result.customer_id ?? null,
        });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setTemplateData({
          logoImageUrl: logo,
          secondaryImageUrl: secondaryImage,
        });
      });
  }

  async function checkCouponValidation() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/v5/orders/users/coupon/${token}/valid`
      );
      return response.data;
    } catch (err) {
      let errorMessage = "Something went wrong.";
      if (err.response && err.response.data && err.response.data.message) {
        errorMessage = err.response.data.message;
      }
      toast.warning(errorMessage, {
        position: "bottom-center",
      });
      return false;
    } finally {
      setLoading(false);
    }
  }

  async function handleNavigation() {
    if (token === "null" || token === undefined || token === null) {
      navigate("/");
      return;
    } else {
      const data = await checkCouponValidation();

      if (data && data.result) {
        if (Boolean(data.result.show_products) === false) {
          try {
            const swagpacks = await getCouponItems();
            setSelectedPack({ selectedPack: swagpacks });
          } catch (error) {
            toast.warning(error.message, {
              position: "bottom-center",
            });
          }
        } else {
          if (Boolean(data.result.has_multiple_choice) === false) {
            navigate({
              pathname: "/redemption/checkout",
              search: `?${createSearchParams(params)}`,
            });
          } else {
            navigate({
              pathname: "/redemption/checkout",
              search: `?${createSearchParams(params)}`,
            });
          }
        }
      }
    }
  }

  async function getCouponItems() {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_URL}/v4/customer/redemption/couponItems?token=${token}`
        )
        .then((res) => {
          if (res.data.success && res.data.result) {
            if (
              res.data.result.swagpacks &&
              res.data.result.swagpacks.length > 0
            ) {
              resolve(res.data.result.swagpacks);
            } else {
              reject(new Error("Failed to fetch swagpacks."));
            }
          }
        })
        .catch((err) => {
          let errorMessage = "Something went wrong.";
          if (err.response && err.response.data && err.response.data.message) {
            errorMessage = err.response.data.message;
          }
          reject(new Error(errorMessage));
        });
    });
  }

  return (
    <>
      {loading ? (
        <div className="loading-indicator-admin"></div>
      ) : (
        <>
          <div
            id="container"
            className="container-fluid"
            style={{
              backgroundColor: templateData.backgroundColor || "#2c4c93",
            }}
          >
            <ToastContainer />

            <div
              className="container-fluid"
              id="redemption-demo-page"
              style={{}}
            >
              <div className="row pt-2">
                <div className="col-xl-1 col-lg-1 col-md-1 col-sm-12 col-12"></div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div className="d-flex justify-content-start">
                    <GradientHeader
                      logoSrc={templateData.logoImageUrl}
                      justifyContent="flex-start"
                      headerColor={templateData.headerColor}
                    />
                  </div>
                </div>
              </div>
              {/* Use the reusable LayoutComponent */}
              <LayoutComponent
                layout={templateData.layout}
                templateData={templateData}
                onButtonClick={handleNavigation}
                secondaryImage={secondaryImage}
              />
              {/* <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 footer text-center">
                <a
                  href="https://swageazy.com/"
                  target={"_blank"}
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <p
                    className="heading-5"
                    style={{ color: templateData.textColor }}
                  >
                    © 2025, Powered by Swageazy
                  </p>
                </a>
              </div> */}
              {templateData.customerId !== 383 && (
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 footer text-center">
                  <a
                    href="https://swageazy.com/"
                    target={"_blank"}
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    <p className="heading-5">© 2025, Powered by Swageazy</p>
                  </a>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};
